import { PdvService } from './../pdv/pdv.service';
import { WebSiteUsersService } from '../webSiteUsers/webSiteUsers.service';
import { Injectable } from '@angular/core';
import { Router} from '@angular/router';
import { AuthService } from '../Auth/auth.service';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable,throwError   } from 'rxjs';
import { catchError} from "rxjs/operators";
import { localStorageService } from '../localStorage/localStorage.service';
@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
    constructor(
        private auth: AuthService,
        private router: Router,
        private webSiteUsersService: WebSiteUsersService,
        private pdvService:PdvService,
        private localStorage:localStorageService
    ) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = this.localStorage.getItem('token');
        const idPdv =this.pdvService.idPdv;
        if (token) {
            req = req.clone({ setHeaders: { token: `${token}` } });
        }
        req = req.clone({ setHeaders: { pdv: `${idPdv}` } });
        return next.handle(req).pipe(
                catchError(  (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401) {
                            this.localStorage.clear();
                            this.webSiteUsersService.listener.next(false);
                            this.router.navigate(['/']);
                        }
                    }
                    return throwError(err);
                })
            
          );
    }
}